import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import dayjs from 'dayjs';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReplaySubject, takeUntil } from 'rxjs';
import { AnalyticsService } from '../../@core/utils';
import {
  schoolEndTimeValidator,
  validateAlphanumericWithSpecialCharacters,
  validateNameAndSpaceAndSpecialCharacters,
  validateNameWithSpacesAndHyphens,
} from '../../@theme/directives/validators';
import { CUSTOM_EVENTS } from '../../config/custom_events';
import { WEEK_DAY_MAP, WeekDays } from '../../config/week-days';
import { ClearObservableHelper } from '../../helpers/ClearObservableHelper';
import { formatTime } from '../../helpers/dateTimeFormatter';
import { SchoolCalendar } from '../../interface/calendar';
import { School } from '../../interface/school';
import { UserData } from '../../interface/user';
import { AuthService } from '../../services/auth.service';
import { CalendarService } from '../../services/calendar.service';
import { SchoolService } from '../../services/school.service';
import { StorageService } from '../../services/storage.service';
import { ToasterService } from '../../services/toaster.service';
import { MatDialogComponent } from '../mat-dialog/mat-dialog.component';
import { ROLEVALUES } from './../../enum/roles.enum';
import { UtilService } from './../../services/util.service';

@Component({
  selector: 'ngx-instructional-periods',
  templateUrl: './instructional-periods.component.html',
  styleUrls: ['./instructional-periods.component.scss'],
})
export class InstructionalPeriodsComponent extends ClearObservableHelper implements OnInit, OnDestroy {
  user: UserData;
  schoolForm: FormGroup;
  addSchoolPeriodForm: FormGroup;
  @ViewChild('myModal') myModal: TemplateRef<any>;
  @ViewChild('selectBellSchedules') selectBellSchedules: TemplateRef<any>;
  public modalRef;
  school: School | any;
  loadingText = 'Please Wait...';
  // title = '';
  loading = false;
  weekDays = Object.values(WeekDays);
  private dialogRef: NbDialogRef<any>;
  isAdminiStration = false;
  isEdit = false;
  teacherSchoolPeriods: any = [];
  bellShedules = [];
  selectedSchoolBellSchedules = [];
  currentBellShedule;
  currentSelectedBellSchedule;
  selectedType;
  @ViewChild('editBellScheduleName') editBellScheduleName: TemplateRef<any>;
  schools: any = [];
  currentSchool: School;
  isModal = false;
  nameOfBellSchedule: string;
  public schoolFilterCtrl: FormControl = new FormControl();
  public schoolCtrl: FormControl = new FormControl();
  public filteredSchool: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  currentSchoolId;
  public bellScheduleName = '';
  customEvents = CUSTOM_EVENTS;
  isTeacherOnly: boolean = false;
  isManageSchoolYear: boolean;
  @Input() resetForm: boolean;
  @Input() manageSchoolYear: boolean = false;
  @Input() title: string;
  schoolCalendarData: SchoolCalendar;
  isNavigatedBack: boolean;
  calendarData: any;
  calendarsAddedForSchool: SchoolCalendar[]; //variable to store all the calendars for the selected school
  selectedSchoolCalendar: SchoolCalendar; //variable to store the selected calendar for the selected school
  isTeacherManagement: boolean = false;
  constructor(
    private storageService: StorageService,
    private schoolService: SchoolService,
    private fb: FormBuilder,
    public modalService: NgbModal,
    public router: Router,
    private calendarService: CalendarService,
    private toasterService: ToasterService,
    private dialogService: NbDialogService,
    private authService: AuthService,
    public matDialog: MatDialog,
    public analyticsService: AnalyticsService,
    public spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private utilService: UtilService,
  ) {
    super();
  }
  async ngOnInit() {
    try {
      this.getFormControl();
      this.spinner.show('instructionalPeriodSpinner');
      this.currentSchoolId = parseInt(this.route.snapshot.paramMap.get('id'), 10);

      this.isTeacherManagement = this.router.url.includes('teacher-management') ? true : false;
      this.isManageSchoolYear = this.router.url.includes('manage-school-years') ? true : false;
      // variable use to check if user pressed an back button or not
      this.isNavigatedBack = Boolean(this.route.snapshot.paramMap.get('isNavigateBack'));
      this.selectedSchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');

      // If users wants to navigate back, then get the calendar data by ID
      if (this.isNavigatedBack) {
        this.calendarData = await this.calendarService.schoolCalendarById(
          parseInt(this.route.snapshot.paramMap.get('calendarId'), 10),
        );
      }

      this.isAdminiStration =
        // Check if managing school year and instructional periods from administration module
        this.router.url.includes('administration') || this.router.url.includes('manage-school-years') ? true : false;

      this.user = this.storageService.getItem('user');
      if (this.user.user.role_id === ROLEVALUES.TEACHER_ONLY) {
        this.isTeacherOnly = true;
      }

      //Get all calendar data by school ID
      await this.getSchoolCalendarsById();
      await this.getSchoolData();
      this.handleCalendarChangeData();
      this.spinner.hide('instructionalPeriodSpinner');

      await this.storageService.setSelectedSchoolsToLocalStorage
        .pipe(takeUntil(this.destroy$))
        .subscribe(async (res) => {
          if (res) {
            this.spinner.show('instructionalPeriodSpinner');
            await this.getSchoolData();
            this.spinner.hide('instructionalPeriodSpinner');
          }
        });
      this.schools = await this.schoolService.getMultipleSchoolsByIds({
        school_ids: this.adminSchools(),
      });
      const index = this.schools.findIndex((x) => x.id === this.user?.user?.school?.id);

      if (index !== -1) {
        this.schools.splice(index, 1);
      }
      this.schoolFilterCtrl.valueChanges.subscribe(() => {
        this.filterSchool();
      });
      this.updateBellScheduleValidator();
      this.resetSchoolForm(); // for new school year
    } catch (error) {
      console.log('ngOnInit', error);
      this.spinner.hide('instructionalPeriodSpinner');
    }
  }

  async getSchoolData(id?: number) {
    try {
      // if (this.user.user.role_id !== ROLEVALUES.TEACHER_ONLY) {
      this.school = this.currentSchoolId
        ? await this.schoolService.schoolById(this.currentSchoolId)
        : await this.schoolById();
      // }
      if (this.router?.url?.includes('teacher')) {
        // Fetch the teacher's custom-created bell schedule
        // Condition is commented out to ensure the schedule persists on page refresh or when data already exists
        //  if (!this.isTeacherManagement) {
        this.teacherSchoolPeriods = await this.getUserSchoolPeriods();
        // }
      } else {
        await this.getSchoolBellShedules(id);
      }
      await this.sortWeekDays();
      await this.patchSchoolValue();
    } catch (error) {
      // console.log(error);
    }
  }

  /**
   * @description
   * Fetches the bell schedules for a school based on the school ID and, if applicable, the school calendar ID.
   * If `isManageSchoolYear` is `true`, it includes the calendar ID in the request; otherwise, it fetches based only on the school ID.
   * The selected bell schedule is set based on the provided `id` or defaults to the first schedule.
   *
   * @param {number} [id] - Optional bell schedule ID to select as the current schedule.
   * @return {Promise<void>} A promise that resolves once schedules are fetched and assigned.
   */
  async getSchoolBellShedules(id?: number) {
    try {
      let schoolCalendarId = 0;

      if (this.isManageSchoolYear) {
        const fetchedCalendarId = this.storageService.getItem('currentCalendarId');
        schoolCalendarId = fetchedCalendarId
          ? fetchedCalendarId
          : this.isNavigatedBack
            ? parseInt(this.route.snapshot.paramMap.get('calendarId'), 10)
            : 0;
      } else {
        // For getting the bell shedules for selected calendar in admin instructional period menu
        schoolCalendarId =
          (this.selectedSchoolCalendar && !this.selectedSchoolCalendar.isFirst ? this.selectedSchoolCalendar.id : 0) ||
          0;
      }
      const response = await this.schoolService.getSchoolBellShedules({
        school_id: this.school?.id,
        school_calendar_id: schoolCalendarId,
      });
      if (!this.isManageSchoolYear) {
        if (this.school?.school_periods?.length > 0) {
          this.bellShedules = [
            {
              bell_schedule: this.school?.school_periods,
              school_id: this.school?.id,
              name: this.school?.schoolData?.bell_schedule_name,
            },
            ...response,
          ];
          if (this.selectedSchoolCalendar?.id && response.length > 0 && !this.selectedSchoolCalendar?.isFirst) {
            this.bellShedules = this.bellShedules.filter(
              (x) => x.school_calendar_id === this.selectedSchoolCalendar?.id,
            );
          }
        } else {
          this.bellShedules = [];
        }
      } else {
        this.bellShedules = response;
      }

      this.currentBellShedule = id ? this.bellShedules.filter((x) => x.id === id)[0] : this.bellShedules[0];
    } catch (error) {
      console.log('getSchoolBellShedules', error);
    }
  }

  async getCurrentBellShedule(bellShedule, isModal = false) {
    try {
      isModal ? (this.currentSelectedBellSchedule = bellShedule) : (this.currentBellShedule = bellShedule);
    } catch (error) {
      // console.log(error);
    }
  }

  async getUserSchoolPeriods() {
    try {
      const params = {
        user_id: this.user.user.id,
      };
      return await this.schoolService.teacherBellSheduleByUserId(params);
    } catch (error) {
      // console.log(error);
    }
  }

  async sortWeekDays(isSelectionChange = false) {
    try {
      const map = WEEK_DAY_MAP;

      if (isSelectionChange) {
        this.currentSelectedBellSchedule.bell_schedule.sort((a, b) => {
          return map[a.day] - map[b.day];
        });
        return;
      }

      if (this.router.url.includes('teacher')) {
        this.teacherSchoolPeriods[0].school_periods.sort((a, b) => {
          return map[a.day] - map[b.day];
        });
      } else {
        this.school.school_periods.sort((a, b) => {
          return map[a.day] - map[b.day];
        });
      }
    } catch (error) {
      // console.log(error);
    }
  }

  getFormControl(): void {
    this.schoolForm = this.fb.group({
      name: [''],
      code: [''],
      country: ['', [validateNameAndSpaceAndSpecialCharacters]],
      state: ['', [validateNameWithSpacesAndHyphens]],
      city: ['', [validateNameAndSpaceAndSpecialCharacters]],
      phone: [''],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      calendar_title: ['', [validateAlphanumericWithSpecialCharacters]],
    });
    this.addSchoolPeriodForm = this.fb.group({
      days: [[], Validators.required],
      periods: this.fb.array([]),
      name: [''],
    });
    this.validateSchoolDate();
    this.validateSchoolEndTime();
  }

  get options(): FormArray {
    return this.addSchoolPeriodForm.controls.periods as FormArray;
  }

  async addOptions() {
    try {
      if (
        this.options.controls[this.options.controls.length - 1].value.title !== '' &&
        this.options.controls[this.options.controls.length - 1].value.start !== '' &&
        this.options.controls[this.options.controls.length - 1].value.end !== ''
      ) {
        //NBDatepicker library issue
        const option = this.fb.group({
          title: '',
          start: this.options.value[this.options.controls.length - 1].end,
          end: this.options.value[this.options.controls.length - 1].end,
        });
        // const option = this.fb.group({
        //   title: '',
        //   start: '',
        //   end: '',
        // });
        this.options.push(option);
      } else {
        this.toasterService.showToast('Please fill all the fields below', 'info');
      }
    } catch (error) {
      // console.log(error);
    }
  }

  updateBellScheduleValidator() {
    // Ensure `this.user.role_id` is available before updating validators
    if (this.user && this.user.user.role_id !== undefined) {
      const nameControl = this.schoolForm.get('name');
      const codeControl = this.schoolForm.get('code');
      const countryControl = this.schoolForm.get('country');
      const stateControl = this.schoolForm.get('state');
      const cityControl = this.schoolForm.get('city');
      const phoneControl = this.schoolForm.get('phone');

      if (this.user.user.role_id === ROLEVALUES.TEACHER_ONLY) {
        nameControl?.clearValidators(); // No validators for TEACHER_ONLY
        codeControl?.clearValidators(); // No validators for TEACHER_ONLY
        countryControl?.clearValidators(); // No validators for TEACHER_ONLY
        stateControl?.clearValidators(); // No validators for TEACHER_ONLY
        cityControl?.clearValidators(); // No validators for TEACHER_ONLY
        phoneControl?.clearValidators(); // No validators for TEACHER_ONLY
      } else {
        nameControl?.setValidators(Validators.required); // Add required validator for others
        codeControl?.setValidators(Validators.required); // Add required validator for others
        countryControl?.setValidators(Validators.required); // Add required validator for others
        stateControl?.setValidators(Validators.required); // Add required validator for others
        cityControl?.setValidators(Validators.required); // Add required validator for others
        phoneControl?.setValidators(Validators.required); // Add required validator for others
      }
      nameControl?.updateValueAndValidity(); // Refresh validation state
      codeControl?.updateValueAndValidity(); // Refresh validation state
      countryControl?.updateValueAndValidity(); // Refresh validation state
      stateControl?.updateValueAndValidity(); // Refresh validation state
      cityControl?.updateValueAndValidity(); // Refresh validation state
      phoneControl?.updateValueAndValidity(); // Refresh validation state
    }
  }

  async deleteOptions(index) {
    try {
      this.options.removeAt(index);
    } catch (error) {
      // console.log(error);
    }
  }

  async schoolById() {
    try {
      const localStorageSchool = this.storageService.getItem('selectedSchoolByAdmin');

      // Updating the condition so that admin can create the new year with school selected in the header
      const id =
        localStorageSchool?.id && !this.router.url.includes('administration') && !this.router.url.includes('teacher')
          ? localStorageSchool?.id
          : null;
      return await this.schoolService.schoolById(id ? id : this.user.user.school_id ? this.user.user.school_id : 0);
    } catch (error) {
      // console.log(error);
    }
  }

  editInstructionalPeriods(schoolPeriod): void {
    try {
      if (this.user.user.is_trial_user) {
        this.toasterService.showToast('You can edit/update instructional periods from here', 'info');
        return;
      }
      this.selectedType = this.currentBellShedule?.id ? '2' : '1';
      this.addSchoolPeriodForm.patchValue({
        days: [schoolPeriod?.day],
        name: this.currentBellShedule?.id ? this.currentBellShedule?.name : '',
      });

      this.options.clear();

      for (const iterator of schoolPeriod?.periods) {
        // Temporarily remove for nb-datepicker issues
        this.options.push(
          this.fb.group({
            title: iterator.title,
            start: new Date(iterator.start),
            end: new Date(iterator.end),
          }),
        );
        // this.options.push(
        //   this.fb.group({
        //     title: iterator.title,
        //     start: '',
        //     end: '',
        //   }),
        // );
      }
      this.openPeriodModal();
    } catch (error) {
      // console.log(error);
    }
  }

  async openSchoolPeriodModal(dialog?) {
    try {
      if (this.user?.user?.is_trial_user) {
        this.toasterService.showToast('You can create bell schedule from here', 'info');
        return;
      }

      if (this.router.url.includes('teacher')) {
        this.teacherPeriodModal();
      } else {
        // Check if a given date range overlaps with any existing calendars.
        const checkIfCalendarIsValid = this.checkIfCalendarOverlaps();
        if (checkIfCalendarIsValid) {
          return;
        }
        this.schoolPeriodModal(dialog);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  teacherPeriodModal(): void {
    try {
      if (this.teacherSchoolPeriods && this.teacherSchoolPeriods.length > 0) {
        if (this.teacherSchoolPeriods[0].school_periods.length < 5) {
          this.weekDays = Object.values(WeekDays);
          for (const iterator of this.teacherSchoolPeriods[0].school_periods) {
            this.weekDays.splice(this.weekDays.indexOf(iterator.day), 1);
          }
          this.openTeacherModal();
        } else {
          this.toasterService.showToast('You have added bell schedule for all the working days', 'info');
        }
      } else {
        this.openTeacherModal();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  openTeacherModal(): void {
    this.addSchoolPeriodForm.reset();
    this.options.clear();

    // Temporarily remove for nb-datepicker issues
    this.options.push(
      this.fb.group({
        title: '',
        start: new Date(
          this.selectedSchoolCalendar && !this.selectedSchoolCalendar.isFirst
            ? this.selectedSchoolCalendar.extras.startTime
            : this.school.start_time,
        ),
        end: new Date(
          this.selectedSchoolCalendar && !this.selectedSchoolCalendar.isFirst
            ? this.selectedSchoolCalendar.extras.startTime
            : this.school.start_time,
        ),
      }),
    );
    // this.options.push(
    //   this.fb.group({
    //     title: '',
    //     start: '',
    //     end: '',
    //   }),
    // );

    this.openPeriodModal();
  }

  schoolPeriodModal(dialogRef): void {
    try {
      this.selectedType = null;
      if (
        this.schoolForm.value.startDate &&
        this.schoolForm.value.endDate &&
        this.schoolForm.value.startTime &&
        this.schoolForm.value.endTime
      ) {
        if (this.bellShedules?.length > 0) {
          this.openSelectBellSheduleModal(dialogRef);
        } else {
          this.selectedType = '2';
          this.openBellShedulePeriodsModal(dialogRef);
        }
      } else {
        this.toasterService.showToast('Please add school start and end, dates and times respectively', 'warning');
      }
    } catch (error) {
      // console.log(error)
    }
  }

  openModalAsPerSelectedType(): void {
    this.selectedType === '1' ? this.openBellShedulePeriodsModal() : this.openBellShedulePeriodsModal(true);
  }

  openSelectBellSheduleModal(dialog): void {
    this.dialogService.open(dialog);
  }

  openBellShedulePeriodsModal(isOpenNew = false): void {
    try {
      const periods = this.currentBellShedule?.bell_schedule;

      this.weekDays = Object.values(WeekDays);

      if (!isOpenNew)
        for (const iterator of periods) {
          this.weekDays.splice(this.weekDays.indexOf(iterator.day), 1);
        }

      if (this.weekDays.length > 0) {
        this.addSchoolPeriodForm.reset();
        this.options.clear();
        // NBDatepicker library issue
        this.options.push(
          this.fb.group({
            title: '',
            start: this.schoolForm.value.startTime,
            end: this.schoolForm.value.startTime,
          }),
        );
        // this.options.push(
        //   this.fb.group({
        //     title: '',
        //     start: '',
        //     end: '',
        //   }),
        // );
        this.openPeriodModal();
        // Do not overwrite the bell schedule name while managing school years
        if (!this.isManageSchoolYear && this.school?.schoolData?.bell_schedule_name && !isOpenNew) {
          this.addSchoolPeriodForm.patchValue({
            name: this.school.schoolData.bell_schedule_name,
          });
        }
      } else {
        this.toasterService.showToast('You have added periods for all the Weekdays', 'danger');
      }
    } catch (error) {
      // console.log(error);
    }
  }

  openPeriodModal(): void {
    this.modalRef = this.modalService.open(this.myModal, {
      size: 'lg',
      modalDialogClass: 'mymodal',
      centered: true,
      backdrop: 'static',
      animation: true,
      keyboard: false,
      backdropClass: 'modal-backdrop',
      windowClass: 'custom-overlay-container',
    });
  }

  async patchSchoolValue() {
    try {
      let startTime: any;
      let endTime: any;
      // Added check to avoid patching values when managing school years
      if (!this.isManageSchoolYear) {
        if (this.school?.start_time && this.school?.end_time) {
          startTime = {
            hour:
              new Date(this.school.start_time).getHours() % 12 === 0
                ? '12'
                : new Date(this.school.start_time).getHours() % 12 < 10
                  ? '0' + (new Date(this.school.start_time).getHours() % 12)
                  : new Date(this.school.start_time).getHours() % 12,
            minute:
              new Date(this.school.start_time).getMinutes() < 10
                ? '0' + new Date(this.school.start_time).getMinutes()
                : new Date(this.school.start_time).getMinutes(),
            amPm: new Date(this.school.start_time).getHours() >= 12 ? 'PM' : 'AM',
          };
          endTime = {
            hour:
              new Date(this.school.end_time).getHours() % 12 === 0
                ? '12'
                : new Date(this.school.end_time).getHours() % 12 < 10
                  ? '0' + (new Date(this.school.end_time).getHours() % 12)
                  : new Date(this.school.end_time).getHours() % 12,
            minute:
              new Date(this.school.end_time).getMinutes() < 10
                ? '0' + new Date(this.school.end_time).getMinutes()
                : new Date(this.school.end_time).getMinutes(),
            amPm: new Date(this.school.end_time).getHours() >= 12 ? 'PM' : 'AM',
          };
        }
      }
      this.schoolForm.patchValue({
        name: this.school.name,
        code: this.school.code,
        country: this.school.country,
        state: this.school.state,
        city: this.school.city,
        phone: this.school.phone,
      });
      // Added check to avoid patching values when managing school years
      if (!this.isManageSchoolYear) {
        if (this.selectedSchoolCalendar && this.selectedSchoolCalendar?.id) {
          //Fetch calendar data by ID to retrieve the updated information for the selected academic year and display it in the Admin Instructional Periods module.
          const calendarData: any = await this.calendarService.schoolCalendarById(this.selectedSchoolCalendar?.id);
          if (calendarData) {
            this.schoolForm.patchValue({
              startDate: calendarData.start ? new Date(calendarData.start).toDateString() : null,
              endDate: calendarData.end ? new Date(calendarData.end).toDateString() : null,
              startTime: calendarData.extras?.startTime
                ? new Date(calendarData.extras?.startTime)
                    .toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true,
                    })
                    .toUpperCase()
                : startTime.hour + ':' + startTime.minute + ' ' + startTime.amPm,
              endTime: calendarData.extras?.endTime
                ? new Date(calendarData.extras.endTime)
                    .toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true,
                    })
                    .toUpperCase()
                : endTime.hour + ':' + endTime.minute + ' ' + endTime.amPm,
            });
          }
        } else {
          this.schoolForm.patchValue({
            startDate: this.school.start_date
              ? this.router.url.includes('teacher') || !this.router.url.includes('administration')
                ? new Date(this.school.start_date).toDateString()
                : new Date(this.school.start_date)
              : null,
            endDate: this.school.end_date
              ? this.router.url.includes('teacher') || !this.router.url.includes('administration')
                ? new Date(this.school.end_date).toDateString()
                : new Date(this.school.end_date)
              : null,
            startTime: this.school.start_time
              ? this.router.url.includes('teacher') || !this.router.url.includes('administration')
                ? startTime.hour + ':' + startTime.minute + ' ' + startTime.amPm
                : new Date(this.school.start_time)
              : null,
            endTime: this.school.end_time
              ? this.router.url.includes('teacher') || !this.router.url.includes('administration')
                ? endTime.hour + ':' + endTime.minute + ' ' + endTime.amPm
                : new Date(this.school.end_time)
              : null,
            calendar_title: this.school?.schoolData?.calendar_title || '',
          });
        }
      } else {
        // If user navigates back to the 1st onboarding process
        if (this.isNavigatedBack) {
          this.schoolForm.patchValue({
            startDate: this.calendarData?.start ? new Date(this.calendarData.start) : null,
            endDate: this.calendarData?.end ? new Date(this.calendarData.end) : null,
            startTime: this.calendarData?.extras?.startTime ? new Date(this.calendarData.extras.startTime) : null,
            endTime: this.calendarData?.extras?.endTime ? new Date(this.calendarData.extras.endTime) : null,
            calendar_title: this.calendarData?.calendar_title || '',
          });
        } else {
          // patch the data on the refresh
          const calendarId = this.storageService.getItem('currentCalendarId') || 0;
          if (calendarId > 0) {
            const calendarData: any = await this.calendarService.schoolCalendarById(calendarId);
            if (calendarData) {
              this.schoolForm.patchValue({
                startDate: calendarData.start ? new Date(calendarData.start) : null,
                endDate: calendarData.end ? new Date(calendarData.end) : null,
                startTime: calendarData.extras?.startTime ? new Date(calendarData.extras.startTime) : null,
                endTime: calendarData.extras?.endTime ? new Date(calendarData.extras.endTime) : null,
                calendar_title: calendarData.calendar_title || '',
              });
            }
          }
        }
      }
    } catch (error) {
      console.log('patchSchoolValue', error);
    }
  }

  async submit(dialog?) {
    try {
      if (this.user?.user?.is_trial_user) {
        this.router.navigateByUrl('/calendar/administration');
        return;
      }

      if (this.schoolForm.invalid) {
        Object.keys(this.schoolForm.controls).forEach((field) => {
          const control = this.schoolForm.get(field);

          control.markAsTouched({
            onlySelf: true,
          });
        });
      } else if (!this.checkSchoolPeriodValidation()) {
        this.toasterService.showToast(
          'Some periods are outside the allowed school hours. Please review the bell schedule.',
          'danger',
        );
        return;
      } else {
        this.loading = true;
        this.dialogRef ? this.dialogRef.close() : null;
        if (!dialog) {
          // Directly save and update school periods without confirmation dialog

          await this.updateSchoolPeriodValues(this.isManageSchoolYear ? true : false);
        } else {
          // this.dialogRef = this.dialogService.open(dialog);
          this.openConfirmDialog();
        }
        this.loading = false;
      }

      this.updateUser();
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }

  saveTeacherPeriods(): void {
    try {
      this.spinner.show('instructionalPeriodSpinner');
      this.dialogRef?.close();

      setTimeout(async () => {
        await this.createNewSchoolForUser();
        // this.router.navigateByUrl('/administration/teacher-periods');
        this.title === 'teacherNewAcademicYearSetup'
          ? this.router.navigateByUrl(`/teacher-management/teacher-weekly-period`)
          : this.router.navigateByUrl('/administration/teacher-periods');
      }, 1000);
      this.spinner.hide('instructionalPeriodSpinner');
    } catch (error) {
      this.spinner.hide('instructionalPeriodSpinner');
      console.log('saveTeacherPeriods', error);
    }
  }

  saveTeacherShedule(dialog) {
    try {
      if (this.schoolForm.invalid) {
        Object.keys(this.schoolForm.controls).forEach((field) => {
          const control = this.schoolForm.get(field);
          control.markAsTouched({
            onlySelf: true,
          });
        });
      } else {
        this.spinner.show('instructionalPeriodSpinner');
        // Validate that at least one bell schedule is added before proceeding with teacher schedule creation
        if (!this.teacherSchoolPeriods[0]?.school_periods) {
          this.toasterService.showToast(
            'Please create a bell schedule before proceeding, as it helps in classroom creation.',
            'warning',
          );
          this.spinner.hide('instructionalPeriodSpinner');
          return;
        }
        !this.teacherSchoolPeriods[0]?.school_periods || this.teacherSchoolPeriods[0]?.school_periods?.length < 5
          ? (this.dialogRef = this.dialogService.open(dialog))
          : this.saveTeacherPeriods();
        // console.log("save");
        this.spinner.hide('instructionalPeriodSpinner');
      }

      this.updateUser();
    } catch (error) {
      console.log(error);
    }
  }

  async updateUser() {
    try {
      let profileData;
      let teacherInfoData;
      if (this.storageService.checkUserRole(this.user.user.role_id, 'teacher')) {
        profileData = {
          ...this.user.user.profileData,
          currentRoute: `/administration/school-instructional-peroids/teacher/${this.user?.user?.id}`,
        };
        // Update teacher bell schedule only if bellShedule is false and not managing school year
        if (this.user?.user?.teachingInfo?.bellShedule === 'false' && !this.isManageSchoolYear) {
          // Added the selectedSchoolCalendar condition to ensure the user's original onboarded teacherBellScheduleId remains unchanged.
          teacherInfoData = {
            ...this.user.user.teachingInfo,
            teacherBellScheduleId:
              this.selectedSchoolCalendar && !this.selectedSchoolCalendar?.isFirst
                ? this.user.user.teachingInfo?.teacherBellScheduleId
                : this.teacherSchoolPeriods?.[0]?.id,
          };
        }
      } else {
        profileData = {
          ...this.user.user.profileData,
          currentRoute: `/calendar/administration`,
        };
      }
      let body = {
        ...this.user.user,
        profileData: profileData,
      };

      // Update teacher bell schedule only if bellShedule is false and not managing school year
      if (this.user?.user?.teachingInfo?.bellShedule === 'false' && !this.isManageSchoolYear) {
        body['teachingInfo'] = teacherInfoData;
      }

      const updateUser = await this.authService.updateUser(this.user.user.id, body, true);
      if (updateUser) {
        const storageData = await this.storageService.getItem('user');
        this.storageService.removeItem('user');
        storageData.user = updateUser;
        this.storageService.setItem('user', storageData);
      }
    } catch (error) {
      console.log('InstructionalPeriodsComponent ~ updateUser ~ error:', error);
    }
  }

  async updateSchoolPeriodValues(isAddNewYear: boolean) {
    try {
      // Validate that at least one bell schedule is added before proceeding
      if (!this.bellShedules || this.bellShedules?.length === 0) {
        this.toasterService.showToast('Please add at least one bell schedule before proceeding.', 'danger');
        this.spinner.hide('instructionalPeriodSpinner');
        return;
      }
      const storeData = {
        start: dayjs(this.schoolForm.value.startDate).valueOf(),
        end: dayjs(this.schoolForm.value.endDate).valueOf(),
        start_time: dayjs(this.schoolForm.value.startTime).valueOf(),
        end_time: dayjs(this.schoolForm.value.endTime).valueOf(),
      };
      if (!isAddNewYear) {
        const params = {
          school_id: this.school?.id,
        };
        const schoolCalendar = await this.calendarService.schoolEventBySchoolId(params);
        // Update calendar holidays for existing school year
        let customHolidays = [];
        const updatedSchoolData: any = await this.updateSchool(true);
        if (updatedSchoolData?.id) {
          this.school = updatedSchoolData;
          customHolidays = await this.addCustomEventToDataBase(this.school);
        }
        // const schoolId = {
        //   school_id: this.school?.id,
        // };
        // const allCalendarListById =
        //   await this.calendarService.schoolEventBySchoolId(schoolId);
        const body = {
          school_id: schoolCalendar && schoolCalendar.length > 0 ? schoolCalendar[0].school_id : this.school.id,
          start: dayjs(this.schoolForm.value.startDate).valueOf(),
          end: dayjs(this.schoolForm.value.endDate).valueOf(),
          holidays: customHolidays, // Retain existing holidays or add new ones
          pupil_free: schoolCalendar && schoolCalendar.length > 0 ? schoolCalendar[0].pupil_free : [],
          acceleration: schoolCalendar && schoolCalendar.length > 0 ? schoolCalendar[0].acceleration : [],
          unassigned: schoolCalendar && schoolCalendar.length > 0 ? schoolCalendar[0].unassigned : [],
          bank_days: schoolCalendar && schoolCalendar.length > 0 ? schoolCalendar[0].bank_days : [],
          instructional_days: schoolCalendar && schoolCalendar.length > 0 ? schoolCalendar[0].instructional_days : 0,
          calendar_title: this.schoolForm.value?.calendar_title ? this.schoolForm.value?.calendar_title : '',
          isFirst: schoolCalendar?.[0]?.isFirst || false,
          isActivate: schoolCalendar?.[0]?.isActivate || false,
        };

        if (schoolCalendar && schoolCalendar.length > 0) {
          body['school_calendar_id'] = schoolCalendar[0].id;
          // body['optional_alias'] = this.schoolForm.value?.calendar_title ?
          // this.schoolForm.value?.calendar_title : '';
          await this.calendarService.updateSchoolCalendar(schoolCalendar[0].id, body);
        } else {
          // Create new calendar
          body['calendar_title'] = this.schoolForm.value?.calendar_title ? this.schoolForm.value?.calendar_title : '';
          await this.addNewCalendarToSchool();
        }
        this.storageService.setItem('selectedSchoolCalendarDates', storeData);
      } else {
        // //To display predefined custom holidays
        // const customHolidays = await this.addCustomEventToDataBase(this.school);
        // const body = {
        //   school_id: this.school.id,
        //   start: dayjs(this.schoolForm.value.startDate).valueOf(),
        //   end: dayjs(this.schoolForm.value.endDate).valueOf(),
        //   holidays: customHolidays,
        //   pupil_free: [],
        //   acceleration: [],
        //   unassigned: [],
        //   bank_days: [],
        //   instructional_days: 0,
        //   calendar_title: this.schoolForm.value?.calendar_title ? this.schoolForm.value?.calendar_title : '',
        // };
        // //Adding new school year
        // const schoolCalendarData = await this.calendarService.addEvent(body);
        // await this.updateSchool(true, schoolCalendarData?.id);

        /**
         * @description
         * Checks if a `currentCalendarId` exists in local storage. If it doesn't (i.e., it's `0`), a new school calendar is created.
         * If a `currentCalendarId` exists, the existing calendar is updated. Afterward, the school is updated with the relevant calendar ID.
         *
         * The method ensures that either an existing or new school calendar is associated with the school, and updates the school
         * accordingly with the correct calendar ID.
         */
        const currentLocalCalendar = this.storageService.getItem('currentCalendarId') || 0;
        let calendarId: any;

        if (currentLocalCalendar === 0) {
          calendarId = await this.addNewCalendarToSchool();
        } else {
          calendarId = currentLocalCalendar;
          // Fetch existing calendar data if not available
          this.schoolCalendarData =
            this.calendarData ??
            (await this.calendarService.schoolCalendarById(parseInt(localStorage.getItem('currentCalendarId'), 0)));
          await this.updateSchoolCalendar();
        }
        await this.updateSchool(true, calendarId);
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
  @description Creates a new school calendar for the upcoming school year, including predefined custom holidays.
 */
  async addNewCalendarToSchool() {
    try {
      //To display predefined custom holidays
      const customHolidays = await this.addCustomEventToDataBase(this.school);

      const body = {
        school_id: this.school.id,
        start: dayjs(this.schoolForm.value.startDate).valueOf(),
        end: dayjs(this.schoolForm.value.endDate).valueOf(),
        holidays: customHolidays,
        pupil_free: [],
        acceleration: [],
        unassigned: [],
        bank_days: [],
        instructional_days: 0,
        calendar_title: this.schoolForm.value?.calendar_title ? this.schoolForm.value?.calendar_title : '',
        extras: {
          startTime: this.schoolForm.value.startTime,
          endTime: this.schoolForm.value.endTime,
        }, //store the start and end time with calendar
        isFirst: this.isManageSchoolYear ? false : true,
        isActivate: false,
      };
      //Adding new school year
      const schoolCalendarData = await this.calendarService.addEvent(body);
      this.storageService.setItem('currentCalendarId', schoolCalendarData.id);
      this.schoolCalendarData = schoolCalendarData;
      return schoolCalendarData.id;
    } catch (error) {
      console.log('addNewCalendarToSchool ~ error:', error);
    }
  }

  /**
  @description Updates the existing school calendar if the form has been modified.
 */
  async updateSchoolCalendar() {
    try {
      if (this.schoolForm.dirty && this.schoolCalendarData) {
        // Add custom holidays
        const customHolidays = await this.addCustomEventToDataBase(this.school);

        // Set start and end dates using dayjs
        this.schoolCalendarData['start'] = dayjs(this.schoolForm.value.startDate).valueOf();
        this.schoolCalendarData['end'] = dayjs(this.schoolForm.value.endDate).valueOf();
        // Set calendar title with fallback if not provided
        this.schoolCalendarData['calendar_title'] = this.schoolForm.value?.calendar_title || '';

        // Set other properties
        this.schoolCalendarData['holidays'] = customHolidays;
        this.schoolCalendarData['pupil_free'] = [];
        this.schoolCalendarData['acceleration'] = [];
        this.schoolCalendarData['unassigned'] = [];
        this.schoolCalendarData['bank_days'] = [];
        this.schoolCalendarData['instructional_days'] = 0;
        this.schoolCalendarData['extras'] = {
          startTime: this.schoolForm.value.startTime,
          endTime: this.schoolForm.value.endTime,
        }; //update the start and end time
        this.schoolCalendarData['isFirst'] = this.schoolCalendarData?.isFirst || false;
        this.schoolCalendarData['isActivate'] = this.schoolCalendarData?.isActivate || false;

        // Update the school calendar
        await this.calendarService.updateSchoolCalendar(this.schoolCalendarData.id, this.schoolCalendarData);
      }
    } catch (error) {
      console.log('updateSchoolCalendar ~ error:', error);
    }
  }

  /**
   * * Update school details
   * @description Update school details
   * @param calendarId calendarId to navigate to manage school years after update
   * @param isSubmit boolean to check if form is submitted or not
   * @returns Promise<School | void>
   */
  async updateSchool(isSubmit = false, calendarId?: number): Promise<School | void> {
    try {
      const schoolBody = {
        school_id: this.school.id,
        name: this.schoolForm.value.name,
        city: this.schoolForm.value.city,
        state: this.schoolForm.value.state,
        country: this.schoolForm.value.country,
        code: this.schoolForm.value.code,
        phone: this.schoolForm.value.phone,
        school_periods: this.school.school_periods,
        // Retain existing school time and date if not managing school year
        start_time: dayjs(this.schoolForm.value.startTime ?? this.school.start_time).valueOf(),
        end_time: dayjs(this.schoolForm.value.endTime ?? this.school.end_time).valueOf(),
        start_date: dayjs(this.schoolForm.value.startDate ?? this.school.start_date).valueOf(),
        end_date: dayjs(this.schoolForm.value.endDate ?? this.school.end_date).valueOf(),
        isNew: this.school?.isNew ? this.school?.isNew : false,
        limitation_user_number: this.school?.limitation_user_number,
        school_logo_id: this.school?.school_logo_id,
        is_trial_school: this.school?.is_trial_school,
        isSchoolOnboarded: this.school?.isSchoolOnboarded,
        subscription: this.school?.subscription ? this.school?.subscription : false,
        schoolData: {
          ...this.school.schoolData,
          bell_schedule_name: this.isManageSchoolYear
            ? this.school?.schoolData?.bell_schedule_name
            : this.bellShedules?.length === 0
              ? this.addSchoolPeriodForm.value?.name || this.school?.schoolData?.bell_schedule_name
              : this.school?.schoolData?.bell_schedule_name,
        },

        // calendar_title: this.schoolForm.value?.calendar_title
        //   ? this.schoolForm.value?.calendar_title
        //   : '',

        //If the user_limitation is not present for any school, we set the default value to false, as it will not cause any issues when creating a new academic year
        user_limitations: [
          {
            role: 'student',
            isLimitedAccess:
              this.school.user_limitations && this.school.user_limitations[0]
                ? this.school.user_limitations[0].isLimitedAccess
                : false,
          },
          {
            role: 'teacher',
            isLimitedAccess:
              this.school.user_limitations && this.school.user_limitations[1]
                ? this.school.user_limitations[1].isLimitedAccess
                : false,
          },
          {
            role: 'admin',
            isLimitedAccess:
              this.school.user_limitations && this.school.user_limitations[2]
                ? this.school.user_limitations[2].isLimitedAccess
                : false,
          },
        ],
      };
      // Get response after updating school details
      let response;
      if (this.isManageSchoolYear) {
        if (calendarId) {
          this.router.navigateByUrl(`/manage-school-years/${this.school.id}/${calendarId}`);
        }
      } else {
        // Update school details
        response = await this.schoolService.updateSchool(this.school.id, schoolBody);
        if (response && response.id) {
          isSubmit
            ? this.currentSchoolId
              ? this.router.navigateByUrl(`/calendar/administration/${this.currentSchoolId}`)
              : this.router.navigateByUrl('/calendar/administration')
            : await this.getSchoolData();
        }
      }
      return response;
      // After updating route to manage school years
    } catch (error) {
      console.log(error);
    }
  }

  async addTeacherPeriod(isEdit = false) {
    try {
      this.loading = true;

      const checkForEmptyTitle = this.options?.controls?.filter((control) => control.value.title === '');
      if (checkForEmptyTitle && checkForEmptyTitle.length > 0) {
        this.toasterService.showToast('Title should not be empty', 'danger');
        return;
      }
      const start = this.options.value[this.options.controls.length - 1].start;
      const end = this.options.value[this.options.controls.length - 1].end;
      // teacher's only portal
      let isTimeStart, isTimeEnd;
      if (this.user.user.role_id === ROLEVALUES.TEACHER_ONLY) {
        isTimeStart = this.schoolForm.value.startTime;
        isTimeEnd = this.schoolForm.value.endTime;
      } else {
        isTimeStart = await this.isTimeBetween(new Date(start));
        isTimeEnd = await this.isTimeBetween(new Date(end));
      }

      if (!isTimeStart || !isTimeEnd) {
        this.loading = false;
        this.toasterService.showToast('You cannot add periods before school start time and after end time', 'danger');
        return;
      }
      const isValid = await this.validSchoolPeriodTime();
      if (isValid) {
        if (this.addSchoolPeriodForm.value.days && this.addSchoolPeriodForm.value.days.length > 0) {
          this.modalRef.close();
          if (this.teacherSchoolPeriods && this.teacherSchoolPeriods.length > 0) {
            await this.updateTeacherPeriods(isEdit);
          } else {
            await this.addTeacherPeriods();
          }
        } else {
          this.toasterService.showToast('Please select days', 'danger');
        }
      }

      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.log('addTeacherPeriod', error);
    }
  }
  // Check the start and end time between instructional periods of teacher

  async isTimeBetween(date2) {
    let calendarData;
    if (this.selectedSchoolCalendar && this.selectedSchoolCalendar?.id) {
      //Fetch calendar data by ID to retrieve the updated information for the selected academic year and display it in the Admin Instructional Periods module.
      calendarData = await this.calendarService.schoolCalendarById(this.selectedSchoolCalendar?.id);
    }
    // Extract hours and minutes for each date
    const time1 =
      new Date(
        this.isManageSchoolYear
          ? this.schoolForm.value.startTime
          : calendarData && calendarData.id
            ? calendarData.extras.startTime
            : this.school.start_time,
      ).getHours() *
        60 +
      new Date(
        this.isManageSchoolYear
          ? this.schoolForm.value.startTime
          : calendarData && calendarData.id
            ? calendarData.extras.startTime
            : this.school.start_time,
      ).getMinutes();

    const time2 = date2.getHours() * 60 + date2.getMinutes();

    const time3 =
      new Date(
        this.isManageSchoolYear
          ? this.schoolForm.value.endTime
          : calendarData && calendarData.id
            ? calendarData.extras.endTime
            : this.school.end_time,
      ).getHours() *
        60 +
      new Date(
        this.isManageSchoolYear
          ? this.schoolForm.value.endTime
          : calendarData && calendarData.id
            ? calendarData.extras.endTime
            : this.school.end_time,
      ).getMinutes();
    // Check if time of date2 is between time of date1 and date3
    return time2 >= time1 && time2 <= time3;
  }

  async addTeacherPeriods() {
    try {
      await this.updateSchoolPeriods();
      this.setTeacherPeriods();
      const response = await this.schoolService.addTeacherBellShedule(this.teacherSchoolPeriods[0]);

      if (response && response.id) {
        this.teacherSchoolPeriods = await this.getUserSchoolPeriods();
        await this.sortWeekDays();
        if (!this.isTeacherManagement) return;

        // update the teacher created bell schedule ID in the academic information table
        const params = {
          user_id: this.user?.user?.id,
          school_id: this.user?.user?.school_id,
          school_calendar_id: this.selectedSchoolCalendar?.id || 0,
        };

        const academicInfo = await this.calendarService.academicInformationByCalendarId(params);
        if (!academicInfo?.length) return;

        const academicRecord = academicInfo[0];
        academicRecord.teachingInfo = {
          ...academicRecord.teachingInfo,
          teacherBellScheduleId: response.id,
        };

        await this.calendarService.updateTeacherAcademicInformation(academicRecord.id, academicRecord);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  setTeacherPeriods(): void {
    try {
      const teacherPeriods =
        this.teacherSchoolPeriods && this.teacherSchoolPeriods.length > 0
          ? this.teacherSchoolPeriods[0].school_periods
          : [];
      for (const iterator of this.addSchoolPeriodForm.value.days) {
        const body = {
          day: iterator,
          periods: this.addSchoolPeriodForm.value.periods,
        };
        teacherPeriods.push(body);
      }
      this.teacherSchoolPeriods =
        this.teacherSchoolPeriods && this.teacherSchoolPeriods.length > 0
          ? [
              {
                id: this.teacherSchoolPeriods[0].id,
                user_id: this.user.user.id,
                school_periods: teacherPeriods,
                school_calendar_id: this.selectedSchoolCalendar ? this.selectedSchoolCalendar?.id : null,
              },
            ]
          : [
              {
                user_id: this.user.user.id,
                school_periods: teacherPeriods,
                school_calendar_id: this.selectedSchoolCalendar ? this.selectedSchoolCalendar?.id : null,
              },
            ];
    } catch (error) {
      // console.log(error);
    }
  }

  async updateTeacherPeriods(isEdit) {
    try {
      await this.updateSchoolPeriods();
      if (isEdit) {
        this.teacherSchoolPeriods[0].school_periods.splice(
          this.teacherSchoolPeriods[0].school_periods.findIndex(
            (x) => x.day.toLowerCase() === this.addSchoolPeriodForm.value.days[0].toLowerCase(),
          ),
          1,
        );
      }

      this.setTeacherPeriods();

      const response = await this.schoolService.updateTeacherBellShedule(
        this.teacherSchoolPeriods[0].id,
        this.teacherSchoolPeriods[0],
      );

      if (response && response.id) {
        this.teacherSchoolPeriods = await this.getUserSchoolPeriods();
        await this.sortWeekDays();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async getFormPeriods(isPush = false) {
    try {
      const periods = [];
      for (const iterator of this.addSchoolPeriodForm.value.days) {
        const body = {
          day: iterator,
          periods: this.addSchoolPeriodForm.value.periods,
        };
        isPush ? this.currentBellShedule?.bell_schedule.push(body) : periods.push(body);
      }

      return periods;
    } catch (error) {
      // console.log(error);
    }
  }

  async addSchoolPeriod(isEdit = false) {
    try {
      this.loading = true;
      if (!this.addSchoolPeriodForm.value.days || this.addSchoolPeriodForm.value.days.length === 0) {
        this.toasterService.showToast('Please select days', 'danger');
        return;
      }
      //
      const findPeriodsBeyondSchoolTime = this.addSchoolPeriodForm.value?.periods?.filter((period) => {
        const schoolStartTime = moment(
          this.schoolForm.value.startTime ? this.schoolForm.value.startTime : this.school?.start_time,
        ).format('HH:mm');
        const schoolEndTime = moment(
          this.schoolForm.value.endTime ? this.schoolForm.value.endTime : this.school?.end_time,
        ).format('HH:mm');
        const periodStartTime = moment(period?.start).format('HH:mm');
        const periodEndTime = moment(period?.end).format('HH:mm');
        // Compare times
        const isBeforeSchoolStart = moment(periodStartTime, 'HH:mm').isBefore(moment(schoolStartTime, 'HH:mm'));
        const isAfterSchoolEnd = moment(periodEndTime, 'HH:mm').isAfter(moment(schoolEndTime, 'HH:mm'));

        return isBeforeSchoolStart || isAfterSchoolEnd;
      });

      if (findPeriodsBeyondSchoolTime?.length > 0) {
        this.loading = false;
        this.toasterService.showToast('You cannot add periods before school start time and after end time', 'danger');
        return;
      }

      const checkForEmptyTitle = this.options?.controls?.filter((control) => control.value.title === '');
      if (checkForEmptyTitle && checkForEmptyTitle.length > 0) {
        this.toasterService.showToast('Title should not be empty', 'danger');
        return;
      }
      //
      const valid = await this.validSchoolPeriodTime();
      if (valid) {
        this.modalRef.close();
        await this.updateSchoolPeriods();

        const isCurrentBellSchedule = !!this.currentBellShedule?.id;
        let currentCalendarId: any;
        if (this.isManageSchoolYear) {
          // When creating a new school calendar year through "Manage School Year", we need to store the school period data in the bell schedule table.
          // To achieve this, we push a null value into the bell schedule array to satisfy the condition.
          // We then check whether the newly created school ID is present and store the associated calendar ID in the bell schedule table for future reference.
          this.bellShedules.push(null);
          const currentSchoolCalendarId = this.storageService.getItem('currentCalendarId');
          currentCalendarId =
            currentSchoolCalendarId && currentSchoolCalendarId !== 0
              ? currentSchoolCalendarId
              : await this.addNewCalendarToSchool();
        }
        if (this.selectedType === '2' && !isEdit && this.bellShedules?.length !== 0) {
          const periods = await this.getFormPeriods();
          const body: any = {
            school_id: this.school.id,
            bell_schedule: periods,
            name: this.addSchoolPeriodForm?.value?.name,
          };
          if (this.isManageSchoolYear) {
            body.school_calendar_id = currentCalendarId;
          }
          const response = await this.schoolService.addSchoolBellShedule(body);
          this.currentSelectedBellSchedule = response;
          if (response?.id) await this.getSchoolData(response?.id);
        } else {
          if (isEdit) {
            const indexToRemove = this.currentBellShedule
              ? this.currentBellShedule.bell_schedule.findIndex(
                  (x) => x.day.toLowerCase() === this.addSchoolPeriodForm.value.days[0].toLowerCase(),
                )
              : this.school.school_periods.findIndex(
                  (x) => x.day.toLowerCase() === this.addSchoolPeriodForm.value.days[0].toLowerCase(),
                );
            if (indexToRemove !== -1) {
              if (isCurrentBellSchedule) {
                this.currentBellShedule.name = this.addSchoolPeriodForm.value?.name;
                this.currentBellShedule.bell_schedule.splice(indexToRemove, 1);
                await this.getFormPeriods(true);
                const currentBellSheduleRes = await this.schoolService.updateSchoolBellShedule(
                  this.currentBellShedule?.id,
                  this.currentBellShedule,
                );
                if (currentBellSheduleRes?.id) await this.getSchoolData(currentBellSheduleRes?.id);
              } else {
                this.school.school_periods.splice(indexToRemove, 1);
                this.updateSchoolPeriod();
                await this.updateSchool();
              }
            }
          } else {
            if (isCurrentBellSchedule) {
              await this.getFormPeriods(true);
              const updateBellSheduleRes = await this.schoolService.updateSchoolBellShedule(
                this.currentBellShedule?.id,
                this.currentBellShedule,
              );
              if (updateBellSheduleRes?.id) await this.getSchoolData(updateBellSheduleRes?.id);
            } else {
              this.updateSchoolPeriod();
              await this.updateSchool();
            }
          }
        }
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  updateSchoolPeriod() {
    try {
      for (const iterator of this.addSchoolPeriodForm.value.days) {
        const body = {
          day: iterator,
          periods: this.addSchoolPeriodForm.value.periods,
        };
        this.school.school_periods.push(body);
      }

      this.school['schoolData']['bell_schedule_name'] = this.addSchoolPeriodForm.value.name
        ? this.addSchoolPeriodForm.value.name
        : this.school?.schoolData?.bell_schedule_name;
    } catch (error) {
      // console.log(error);
    }
  }

  async updateSchoolPeriods() {
    try {
      this.addSchoolPeriodForm.value.periods.map((period) => {
        period.start = dayjs(period.start).valueOf();
        period.end = dayjs(period.end).valueOf();

        return period;
      });
    } catch (error) {
      // console.log(error);
    }
  }

  changeValue(event, i): void {
    // Temporarily remove for nb-datepicker issues
    this.options.value[i].end = event.time;
    this.addSchoolPeriodForm.patchValue({
      periods: this.options.value,
    });
  }

  async openApplyToAllModal(): Promise<void> {
    const start = this.options.value[this.options.controls.length - 1].start;
    const end = this.options.value[this.options.controls.length - 1].end;

    let isTimeStart, isTimeEnd;
    //  teacher's only portal
    if (this.user.user.role_id === ROLEVALUES.TEACHER_ONLY) {
      isTimeStart = this.schoolForm.value.startTime;
      isTimeEnd = this.schoolForm.value.endTime;
    } else {
      isTimeStart = await this.isTimeBetween(new Date(start));
      isTimeEnd = await this.isTimeBetween(new Date(end));
    }

    if (!isTimeStart || !isTimeEnd) {
      this.loading = false;
      this.toasterService.showToast('You cannot add periods before school start time and after end time', 'danger');
      return;
    }
    try {
      const isValid = await this.validSchoolPeriodTime();
      if (isValid) {
        const dialogRef = this.matDialog.open(MatDialogComponent, {
          width: '400px',
          data: {
            title: 'Apply Instructional Periods',
            icon: '/assets/icons/save-featured-icon.svg',
            accessCodeLabel: 'Apply Instructional Periods',
            confirmationMessage: 'Are you sure want to apply this to all the remaining weekdays ?',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            cancelTrackEvent: 'Cancel Apply Instructional Periods',
            confirmTrackEvent: 'Apply Instructional Periods',
            trackPage: 'Instructional Period',
          },
        });

        dialogRef.afterClosed().subscribe(async (result) => {
          if (result) {
            this.applyInstructionalPeriodsToRemainingDays(this.router.url.includes('teacher') ? true : false);
          }
        });
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async applyInstructionalPeriodsToRemainingDays(isTeacher = false) {
    try {
      this.loading = true;
      // this.dialogRef.close();
      this.modalRef.close();

      isTeacher
        ? await this.applyTeacherInstructionalPeriodsToAllDays()
        : await this.applyInstructionalPeriodsToAllDays();
      this.loading = false;
    } catch (error) {
      // console.log(error);
      this.loading = false;
    }
  }

  async applyTeacherInstructionalPeriodsToAllDays() {
    try {
      const teacherPeriods = [];
      for (const iterator of this.teacherSchoolPeriods[0]?.school_periods) {
        teacherPeriods.push({
          day: iterator.day,
          periods: this.addSchoolPeriodForm.value.periods,
        });
      }

      const response = await this.schoolService.updateTeacherBellShedule(this.teacherSchoolPeriods[0].id, {
        school_periods: teacherPeriods,
        user_id: this.user.user.id,
        school_calendar_id: this.selectedSchoolCalendar ? this.selectedSchoolCalendar?.id : 0,
      });

      if (response && response.id) {
        this.teacherSchoolPeriods = await this.getUserSchoolPeriods();
        await this.sortWeekDays();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async applyInstructionalPeriodsToAllDays() {
    try {
      const currentBellScheulePeriods = this.currentBellShedule?.id
        ? this.currentBellShedule?.bell_schedule
        : this.school?.school_periods;
      const schoolPeriods = [];
      for (const iterator of currentBellScheulePeriods) {
        schoolPeriods.push({
          day: iterator.day,
          periods: this.addSchoolPeriodForm.value.periods,
        });
      }

      if (this.currentBellShedule?.id) {
        this.currentBellShedule.bell_schedule = schoolPeriods;
        this.currentBellShedule.name = this.addSchoolPeriodForm.value.name;
        const response = await this.schoolService.updateSchoolBellShedule(
          this.currentBellShedule?.id,
          this.currentBellShedule,
        );
        if (response?.id) await this.getSchoolData(this.currentBellShedule?.id);
      } else {
        this.school.school_periods = schoolPeriods;

        await this.updateSchool();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async openDeletePlanModal() {
    try {
      const dialogRef = this.matDialog.open(MatDialogComponent, {
        width: '400px',
        data: {
          title: 'Delete Bell Schedule Version',
          icon: '/assets/icons/featured icon.svg',
          accessCodeLabel: 'Delete Bell Schedule Version',
          confirmationMessage: 'Are you sure want to delete this bell schedule version ?',
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Delete',
          cancelTrackEvent: 'Cancel Delete Bell Schedule Version',
          confirmTrackEvent: 'Delete Bell Schedule Version',
          trackPage: 'Bell Schedule Version',
        },
      });
      dialogRef.afterClosed().subscribe(async (result) => {
        if (result) {
          this.delteBellSheduleVersion();
        }
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async delteBellSheduleVersion() {
    try {
      this.loading = true;
      this.matDialog.closeAll();
      if (!this.currentBellShedule.id) {
        if (this.bellShedules && this.bellShedules.length > 1) {
          this.school['school_periods'] = this.bellShedules[1].bell_schedule;
          this.school['schoolData']['bell_schedule_name'] = this.bellShedules[1].name;

          await this.schoolService.deleteBellSchedule(this.bellShedules[1].id);
        } else {
          // While deleting the last bell schedule version, clear the school periods and bell schedule name from the school object
          this.school['school_periods'] = [];
          this.school['schoolData']['bell_schedule_name'] = '';
        }

        await this.schoolService.updateSchool(this.school.id, this.school);
        await this.getSchoolData();
        this.loading = false;
        return;
      }
      await this.schoolService.deleteBellSchedule(this.currentBellShedule?.id);
      await this.getSchoolData();
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error)
    }
  }

  async openSchoolBellSchedulesModal() {
    try {
      if (
        this.schoolForm.value.startDate &&
        this.schoolForm.value.endDate &&
        this.schoolForm.value.startTime &&
        this.schoolForm.value.endTime
      ) {
        this.loading = true;
        this.isModal = true;
        // Check if a given date range overlaps with any existing calendars.
        const checkIfCalendarIsValid = this.checkIfCalendarOverlaps();
        if (checkIfCalendarIsValid) {
          return;
        }
        this.schools = await this.schoolService.getMultipleSchoolsByIds({
          school_ids: this.adminSchools(),
        });

        this.schools.push(this.user.user.school);

        this.schools.splice(
          this.schools.findIndex((x) => x.id === this.school.id),
          1,
        );
        this.filterSchool();

        this.currentSelectedBellSchedule = null;
        this.currentSchool = null;

        this.modalRef = this.modalService.open(this.selectBellSchedules, {
          size: 'xl',
          modalDialogClass: 'mymodal',
          centered: true,
          backdrop: 'static',
          animation: true,
          keyboard: false,
          backdropClass: 'modal-backdrop',
          windowClass: 'custom-overlay-container',
        });
        this.loading = false;
      } else {
        this.toasterService.showToast('Please add school start and end, dates and times respectively', 'danger');
      }
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }
  adminSchools() {
    try {
      const schoolsIds = this?.user?.user.profileData?.selectedSchools;
      return schoolsIds;
    } catch (error) {
      // console.log(error)
    }
  }
  public async getSchoolBellSchedules(school: School) {
    try {
      this.loading = true;

      await this.getSchoolBellScheduleVersions(school);
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  async getSchoolBellScheduleVersions(school?: School) {
    try {
      const response = await this.schoolService.getSchoolBellShedules({
        school_id: school?.id,
        multiple_school_access: true,
      });
      if (school?.school_periods?.length > 0) {
        this.selectedSchoolBellSchedules = [
          {
            bell_schedule: school?.school_periods,
            school_id: school?.id,
            name: school?.schoolData?.bell_schedule_name,
          },
          ...response,
        ];
        // this.bellShedules = this.selectedSchoolBellSchedules;
        // this.currentBellShedule = this.bellShedules[0];
        this.currentBellShedule = this.selectBellSchedules[0];
      } else {
        this.selectedSchoolBellSchedules = [];
      }
      this.currentSelectedBellSchedule = this.selectedSchoolBellSchedules[0];
      await this.sortWeekDays(true);
    } catch (error) {
      // console.log(error);
    }
  }

  async addBellScheduleToCurrentSchool() {
    try {
      this.loading = true;
      this.modalRef.close();
      this.bellShedules.push(this.currentSelectedBellSchedule);

      if (this.isManageSchoolYear && !this.schoolCalendarData?.id) {
        await this.addNewCalendarToSchool();
      }

      if (this.isManageSchoolYear) {
        this.nameOfBellSchedule = this.currentSelectedBellSchedule?.name;
      }

      if (this.isManageSchoolYear || this.bellShedules?.length > 1) {
        await this.addBellScheduleToDatabase(this.isManageSchoolYear ? true : false);
      } else {
        await this.updateCurrentSchoolBellSchedules();
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }
  async addAllBellScheduleToCurrentSchool() {
    try {
      this.loading = true;
      this.modalRef.close();
      this.selectedSchoolBellSchedules.map((bell) => {
        bell.school_id = this.school.id;
        delete bell.id;

        return bell;
      });

      const firstEle = this.selectedSchoolBellSchedules[0];

      if (this.isManageSchoolYear && !this.schoolCalendarData?.id) {
        await this.addNewCalendarToSchool();
      } else {
        if (this.bellShedules?.length === 0) this.selectedSchoolBellSchedules.splice(0, 1);
      }

      const body = {
        bell_schedules: this.selectedSchoolBellSchedules,
      };

      if (this.isManageSchoolYear && this.schoolCalendarData.id) {
        body.bell_schedules.map((x) => (x.school_calendar_id = this.schoolCalendarData.id));
      }
      const response = await this.schoolService.addMultipleSchoolBellShedule(body);
      if (response?.length > 0) {
        if (this.isManageSchoolYear) {
          await this.getSchoolData();
          this.loading = false;
          return;
        }
        //To allow display copy multiple schedule
        // if (this.bellShedules?.length > 1) {
        //   console.log(' if:');
        //   await this.getSchoolData();
        // } else {
        this.school.school_periods = firstEle.bell_schedule;
        await this.updateSchool(false);
      }
      // }

      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  async addBellScheduleToDatabase(newSchoolCalendarYear = false) {
    try {
      const body = {
        school_id: this.school.id,
        bell_schedule: this.currentSelectedBellSchedule?.bell_schedule,
        name: this.nameOfBellSchedule,
      };

      if (newSchoolCalendarYear) {
        body['school_calendar_id'] = this.schoolCalendarData.id;
      }

      const response = await this.schoolService.addSchoolBellShedule(body);
      if (response?.id) await this.getSchoolData(response?.id);
    } catch (error) {
      // console.log(error);
    }
  }

  async updateCurrentSchoolBellSchedules() {
    try {
      this.school.school_periods = this.currentSelectedBellSchedule?.bell_schedule;

      await this.updateSchool(false);
    } catch (error) {
      // console.log(error);
    }
  }
  protected filterSchool() {
    try {
      if (!this.schools) {
        return;
      }
      let search = this.schoolFilterCtrl.value;
      if (!search) {
        this.filteredSchool.next(this.schools.slice());
        return;
      } else {
        search = search.toLowerCase();
      }
      this.filteredSchool.next(
        this.schools.filter((teacher) => teacher.name.toLowerCase().indexOf(search.toLowerCase()) > -1),
      );
    } catch (error) {
      // console.log(error);
    }
  }

  public openEditBellScheduleNameModal(): void {
    try {
      this.bellScheduleName = this.currentBellShedule?.id
        ? this.currentBellShedule.name
        : this.school['schoolData']['bell_schedule_name'];

      this.matDialog.open(this.editBellScheduleName, {
        width: '500px',
        height: '325px',
      });
    } catch (error) {
      // console.log(error);
    }
  }

  public async updateBellScheduleName(): Promise<void> {
    try {
      this.loading = true;

      if (this.bellScheduleName === '') {
        this.toasterService.showToast('Name must contain value', 'danger');
        return;
      }

      this.matDialog.closeAll();

      if (!this.currentBellShedule.id) {
        if (typeof this.school.schoolData === 'string') {
          this.school.schoolData = {};
        }
        this.school['schoolData']['bell_schedule_name'] = this.bellScheduleName;
        await this.schoolService.updateSchool(this.school.id, this.school);
        await this.getSchoolData();
      } else {
        this.currentBellShedule.name = this.bellScheduleName;
        const updatebellSchedule = await this.schoolService.updateSchoolBellShedule(
          this.currentBellShedule.id,
          this.currentBellShedule,
        );
        if (updatebellSchedule && updatebellSchedule.id) {
          await this.getSchoolData(updatebellSchedule?.id);
        }
      }
      this.bellScheduleName = '';
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  public openConfirmDialog(): void {
    // Check if a given date range overlaps with any existing calendars.
    const checkIfCalendarIsValid = this.checkIfCalendarOverlaps();
    if (checkIfCalendarIsValid) {
      return;
    }
    const dialogRef = this.matDialog.open(MatDialogComponent, {
      width: '400px',
      data: {
        title: 'Save Instructional Period',
        icon: '/assets/icons/save-featured-icon.svg',
        accessCodeLabel: 'Save Instructional Period',
        confirmationMessage: ' Are you sure you want to continue with this ?',
        description: ' This will be one time process to create bell schedules',
        cancelButtonText: 'No',
        confirmButtonText: 'Yes',
        cancelTrackEvent: 'Cancel Save Instructional Period',
        confirmTrackEvent: 'Save Instructional Period',
        trackPage: 'Instructional Period',
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.submit();
      }
    });
  }
  /**
   * @description Adjust the custom holidays as per school's start and end date
   * @param currentSchool
   * @returns Promise<SchoolCalendar[]>
   */
  async addCustomEventToDataBase(currentSchool: School) {
    try {
      let adjustedEvents;
      // Adjust the start and end date for new year so that we can add proper events
      if (this.isManageSchoolYear) {
        currentSchool['start_date'] = this.schoolForm.value.startDate;
        currentSchool['end_date'] = this.schoolForm.value.endDate;
        adjustedEvents = this.adjustEventYears(this.customEvents, currentSchool);
      } else {
        // Adjust the start and end date for administration so that we can add proper events
        adjustedEvents = this.adjustEventYears(this.customEvents, currentSchool);
      }
      return adjustedEvents;
    } catch (error) {}
  }

  adjustEventYears(events, currentSchool: School) {
    try {
      const startYear = new Date(currentSchool.start_date).getFullYear();

      const endYear = new Date(currentSchool.end_date).getFullYear();

      const calendarStartDate = new Date(currentSchool.start_date);
      const calendarEndDate = new Date(currentSchool.end_date);
      const updatedEvents = events
        .map((event) => {
          let startDate: any = dayjs(event.start);
          let endDate: any = dayjs(event.end);
          startDate = startDate.$d;
          endDate = endDate.$d;

          if (startYear === endYear) {
            // Update the year of each event to the start year if it's a single-year calendar
            startDate.setFullYear(startYear);
            endDate.setFullYear(startYear);

            // Check if the event falls within the calendar year
            if (
              (startDate >= calendarStartDate && startDate <= calendarEndDate) ||
              (endDate >= calendarStartDate && endDate <= calendarEndDate) ||
              (startDate <= calendarStartDate && endDate >= calendarEndDate)
            ) {
              return {
                ...event,
                start: startDate.getTime(), // Store as timestamp
                end: endDate.getTime(), // Store as timestamp
              };
            }
            return null; // Exclude events outside the calendar year
          } else {
            // Handle the case where the calendar spans multiple years
            const yearlyEvents = [];
            for (let year = startYear; year <= endYear; year++) {
              const newStartDate = new Date(startDate);
              const newEndDate = new Date(endDate);
              // here we have check if endDate is of event is same other add new year
              newStartDate.setFullYear(year);
              newEndDate.setFullYear(year);

              if (newStartDate > newEndDate) {
                newEndDate.setFullYear(year + 1);
              }
              // Check if the yearly event falls within the multi-year calendar range
              if (
                (newStartDate >= calendarStartDate && newStartDate <= calendarEndDate) ||
                (newEndDate >= calendarStartDate && newEndDate <= calendarEndDate) ||
                (newStartDate <= calendarStartDate && newEndDate >= calendarEndDate)
              ) {
                yearlyEvents.push({
                  ...event,
                  start: newStartDate.getTime(), // Store as timestamp
                  end: newEndDate.getTime(), // Store as timestamp
                });
              }
            }
            return yearlyEvents;
          }
        })
        .flat()
        .filter(Boolean); // Remove null values from events outside the calendar range
      return updatedEvents;
    } catch (error) {
      console.error('Error adjusting event years:', error);
      return [];
    }
  }

  async createNewSchoolForUser() {
    if (this.school && this.school.id) {
      const body = this.school;

      // Convert startTime and endTime to Unix timestamps
      if (this.schoolForm.value.startTime) {
        const startTimeParts = this.schoolForm.value.startTime.split(/[: ]/);
        const startHour =
          startTimeParts[2] === 'PM' && +startTimeParts[0] !== 12
            ? +startTimeParts[0] + 12
            : startTimeParts[2] === 'AM' && +startTimeParts[0] === 12
              ? 0
              : +startTimeParts[0];
        const startDate = new Date(this.schoolForm.value.startDate);
        startDate.setHours(startHour, +startTimeParts[1], 0, 0);
        body['start_time'] = startDate.getTime();
      }

      if (this.schoolForm.value.endTime) {
        const endTimeParts = this.schoolForm.value.endTime.split(/[: ]/); // Split into [hour, minute, am/pm]
        const endHour =
          endTimeParts[2] === 'PM' && +endTimeParts[0] !== 12
            ? +endTimeParts[0] + 12
            : endTimeParts[2] === 'AM' && +endTimeParts[0] === 12
              ? 0
              : +endTimeParts[0];
        const endDate = new Date(this.schoolForm.value.endDate);
        endDate.setHours(endHour, +endTimeParts[1], 0, 0);
        body['end_time'] = endDate.getTime();
      }

      body['start_date'] = new Date(this.schoolForm.value.startDate).getTime();
      body['end_date'] = new Date(this.schoolForm.value.endDate).getTime();

      await this.schoolService.updateSchool(this.school.id, body);
    } else {
      const code = this.utilService.randomString(8);
      const getAllSchools = await this.schoolService.getAllSchools();
      if (Array.isArray(getAllSchools)) {
        const isCodeExists = getAllSchools.some((x) => x.code === code);
        if (!isCodeExists) {
          const randomSchoolName = `teachers_only_school_${code}`;
          await this.assignSchoolToUser(randomSchoolName, code);
        }
      }
    }
  }

  async assignSchoolToUser(schoolName: string, code: string) {
    const body = {
      name: schoolName,
      state: '',
      country: '',
      code: code,
      phone: 0,
      school_periods: [],
      start_time: this.schoolForm.value.startTime,
      end_time: this.schoolForm.value.endTime,
      start_date: this.schoolForm.value.startDate,
      end_date: this.schoolForm.value.endDate,
      isNew: true,
      limitedUserNumber: {},
      school_logo_id: 0,
      isSchoolOnboarded: false,
      user_limitations: {},
      is_trial_school: false,
      schoolData: {},
    };
    const res = await this.schoolService.addSchool(body);
    if (res && res.id) {
      const userBody = {
        ...this.user.user,
        school_id: res.id,
        teachingInfo: {
          bellShedule: 'false',
          teachingGrades: this.user.user.teachingInfo.teachingGrades,
          teachingSubject: this.user.user.teachingInfo.teachingSubject,
        },
      };
      const updateUser = await this.authService.updateUser(this.user.user?.id, userBody, true);
      const body = {
        school_id: res.id,
        start: res.start_date,
        end: res.end_date,
        holidays: [],
        pupil_free: [],
        acceleration: [],
        unassigned: [],
        bank_days: [],
        instructional_days: 0,
        isFirst: this.isManageSchoolYear ? false : true,
        isActivate: false,
      };
      await this.calendarService.addEvent(body);
      if (updateUser) {
        const storageData = await this.storageService.getItem('user');
        this.storageService.removeItem('user');
        storageData.user = updateUser;
        this.storageService.setItem('user', storageData);
      }
    }
  }

  async validSchoolPeriodTime() {
    try {
      let isValid = true;
      let duplicateFound = false;
      this.addSchoolPeriodForm.value.periods.forEach((period, index) => {
        // Check the end time is later than the start time
        if (formatTime(period.start) >= formatTime(period.end)) {
          this.toasterService.showToast('End time must be later than the start time.', 'danger');
          isValid = false;
        }

        // Check the start time or end time matches any other period's start time or end time
        for (const [i, existingPeriod] of this.addSchoolPeriodForm.value.periods.entries()) {
          if (i !== index) {
            if (
              formatTime(period.start) === formatTime(existingPeriod.start) ||
              formatTime(period.end) === formatTime(existingPeriod.end)
            ) {
              if (!duplicateFound) {
                this.toasterService.showToast('You cannot add two periods with the same start or end time.', 'danger');
                duplicateFound = true;
              }
              isValid = false;
            }
          }
        }

        // Check the current period's start time is equal to or later than the previous period's end time
        if (index > 0) {
          const prevPeriod = this.addSchoolPeriodForm.value.periods[index - 1];
          if (dayjs(period.start).isBefore(dayjs(prevPeriod.end))) {
            this.toasterService.showToast(
              `Period ${index + 1} start time must be equal to or later than Period ${index} end time.`,
              'danger',
            );
            isValid = false;
          }
        }
      });

      return isValid;
    } catch (error) {
      // console.error(error);
      return false;
    }
  }

  validateSchoolEndTime() {
    this.schoolForm.controls['endTime'].setValidators([
      Validators.required,
      schoolEndTimeValidator(this.schoolForm.controls['startTime']),
    ]);
    this.schoolForm.get('startTime')?.valueChanges.subscribe({
      next: () => {
        this.schoolForm.get('endTime')?.updateValueAndValidity();
      },
      error: (err) => {
        // console.error('Error occurred:', err);
      },
      complete: () => {
        // console.log('Value changes subscription completed');
      },
    });
  }

  validateSchoolDate() {
    const startDateControl = this.schoolForm.controls['startDate'];
    const endDateControl = this.schoolForm.controls['endDate'];

    // Set initial validators for endDate
    const updateEndDateValidators = () => {
      endDateControl.setValidators([Validators.required, schoolEndTimeValidator(startDateControl, true)]);
      endDateControl.updateValueAndValidity({
        onlySelf: true,
        emitEvent: true,
      });
    };
    const onStartDateChange = () => {
      endDateControl.setValue(null);
      updateEndDateValidators();
    };
    startDateControl.valueChanges.subscribe({
      next: onStartDateChange,
      error: (err) => {
        // console.error('Error occurred while observing startDate changes:', err);
      },
      complete: () => {
        // console.log('Start date value changes subscription completed');
      },
    });
    updateEndDateValidators();
  }

  /**
   *  Reset school form values
   *  @returns void
   *  @description This function resets the school form values when its academic new  year form
   */
  resetSchoolForm(): void {
    // Reset the form only if user has not save anything for the school year
    const calendarId = this.storageService.getItem('currentCalendarId');
    if (this.resetForm && !calendarId) {
      this.schoolForm.patchValue({
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: '',
      });
      this.bellShedules = [];
    }
  }

  /**
   * @description Check if a given date range overlaps with any existing calendars.
   * @param newStart - Start date of the new calendar
   * @param newEnd - End date of the new calendar
   * @returns boolean
   */
  hasOverlap(newStart: Date, newEnd: Date): boolean {
    try {
      if (!this.calendarsAddedForSchool?.length) return false;
      return this.calendarsAddedForSchool.some((cal) => newStart <= cal.end && newEnd >= cal.start);
    } catch (error) {
      console.log('InstructionalPeriodsComponent ~ hasOverlap ~ error:', error);
    }
  }

  /**
   * @description Fetch all calendars which has been activated(completed) by the admin for the selected school.
   */
  async getSchoolCalendarsById(): Promise<void> {
    try {
      if (!this.isManageSchoolYear) return;
      const selectedSchoolByAdmin = this.storageService.getItem('selectedSchoolByAdmin') || null;
      const params = {
        school_id: selectedSchoolByAdmin?.id ?? this.user.user.school_id,
      };
      // Only fetch calendars which has been activated(completed) by the admin
      const calendarData = await this.calendarService.schoolCalendarBySchoolId(params);
      this.calendarsAddedForSchool = calendarData.filter((calendar) => calendar.isActivate);
    } catch (error) {
      console.log('InstructionalPeriodsComponent ~ getSchoolCalendarsById ~ error:', error);
    }
  }

  /**
   * @description Check for calendar overlaps before creating or updating a school year.
   * @returns true if overlap detected (and toast shown), false otherwise
   */
  checkIfCalendarOverlaps(): boolean {
    try {
      if (!this.isManageSchoolYear) return false;
      const { startDate, endDate } = this.schoolForm.value;
      const overlap = this.hasOverlap(startDate, endDate);

      if (overlap) {
        this.toasterService.showToast(
          'The selected calendar period overlaps with an existing school year. Please adjust the dates.',
          'danger',
        );
        this.spinner.hide('instructionalPeriodSpinner');
        this.loading = false;
      }

      return overlap;
    } catch (error) {
      console.log('InstructionalPeriodsComponent ~ checkIfCalendarOverlaps ~ error:', error);
      return false;
    }
  }

  /**
   * @description
   * Validates whether the bell schedules for the school are within the specified school start and end times.
   * It checks if each period's start and end times fall within the school's operating hours.
   * Additionally, it ensures that the start time of each period is before the end time.
   *
   * The validation ensures the following:
   * - All periods' times are within the school start and end times (ignoring dates).
   * - The start time of a period is strictly before the end time.
   * - Skips validation if no bell schedules are available or if periods are missing.
   *
   * @return {boolean}
   * - Returns `true` if all periods in the bell schedules are valid.
   * - Returns `false` if any period violates the conditions (outside school hours or invalid start/end times).
   */
  checkSchoolPeriodValidation(): boolean {
    // Check if bell schedules are available
    if (this.bellShedules.length === 0) {
      return true;
    }

    // Convert school start and end times to moment objects and extract time (HH:mm format)
    const schoolStartTime = moment(this.schoolForm.value.startTime).format('HH:mm');
    const schoolEndTime = moment(this.schoolForm.value.endTime).format('HH:mm');

    for (const schedule of this.bellShedules) {
      if (!Array.isArray(schedule?.bell_schedule)) {
        continue;
      }
      // Ensure the 'bell_schedule' array exists for the current day
      for (const period of schedule.bell_schedule) {
        // Ensure periods exist for the current period
        if (!Array.isArray(period?.periods)) {
          continue;
        }

        // Validate each period's start and end time
        for (const periodData of period.periods) {
          // Convert period start and end times to time portion only (HH:mm)
          const periodStartTime = moment(periodData.start).format('HH:mm');
          const periodEndTime = moment(periodData.end).format('HH:mm');

          // Check if the period's start and end times are within school boundaries (time only comparison)
          if (periodStartTime < schoolStartTime || periodEndTime > schoolEndTime) {
            return false;
          }

          // Ensure period start time is before the end time (time only comparison)
          if (periodStartTime >= periodEndTime) {
            return false;
          }
        }
      }
    }
    return true;
  }

  //Handles changes to the selected school calendar by subscribing to updates from local storage.
  async handleCalendarChangeData() {
    this.storageService.setSelectedSchoolsCalendarToLocalStorage
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (res) => {
        if (res) {
          this.spinner.show('instructionalPeriodSpinner');
          this.selectedSchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');
          await this.getSchoolBellShedules();
          await this.getSchoolData();
          this.spinner.hide('instructionalPeriodSpinner');
        }
      });
  }

  /**
   * @description Unsubscribe from all subscriptions to prevent memory leaks when the component is destroyed.
   */
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
